var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "popLogin" } }, [
    _c("div", { attrs: { id: "loginMain" } }, [
      _c("div", { attrs: { id: "login-head" } }, [
        _c(
          "div",
          {
            attrs: { id: "login-head-title" },
            on: { click: _vm.loginTabTitle }
          },
          [
            _vm._v(
              "\n                " + _vm._s(_vm.leftLogin) + "\n            "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { attrs: { id: "login-close" }, on: { click: _vm.closePop } })
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "login-content" } }, [
        _c(
          "div",
          { attrs: { id: "fastLogin" }, on: { click: _vm.loginTabTitle } },
          [
            _vm._v(
              "\n                " + _vm._s(_vm.rightLogin) + "\n            "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "loginWin" }, [
          _vm.loginTabNum == 1
            ? _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userName,
                      expression: "userName"
                    }
                  ],
                  staticClass: "loginInput longInput",
                  attrs: {
                    type: "text",
                    maxlength: "40",
                    placeholder: "用户名/手机号/邮箱"
                  },
                  domProps: { value: _vm.userName },
                  on: {
                    blur: _vm.checkUserName,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.userName = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm.nameErr
                  ? _c("p", { staticClass: "errTip" }, [
                      _vm._v(_vm._s(_vm.nameErrTip))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "passBox" }, [
                  _vm.passType
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "loginInput longInput",
                        attrs: {
                          type: "password",
                          maxlength: "16",
                          placeholder: "密码"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          blur: _vm.checkPassword,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.passType
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "loginInput longInput",
                        attrs: {
                          type: "text",
                          maxlength: "16",
                          placeholder: "密码"
                        },
                        domProps: { value: _vm.password },
                        on: {
                          blur: _vm.checkPassword,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.passType
                    ? _c("img", {
                        staticClass: "passEye",
                        attrs: { src: require("./images/open.png"), alt: "" },
                        on: { click: _vm.changePassType }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.passType
                    ? _c("img", {
                        staticClass: "passEye",
                        attrs: { src: require("./images/close.png"), alt: "" },
                        on: { click: _vm.changePassType }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.passErr
                  ? _c("p", { staticClass: "errTip" }, [
                      _vm._v(_vm._s(_vm.passErrTip))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.imgCode,
                      expression: "imgCode"
                    }
                  ],
                  staticClass: "loginInput midInput",
                  attrs: {
                    type: "text",
                    placeholder: "验证码",
                    maxlength: "4"
                  },
                  domProps: { value: _vm.imgCode },
                  on: {
                    blur: _vm.checkCode,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.imgCode = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "codeImg",
                  attrs: { src: _vm.imgSrc, alt: "" },
                  on: { click: _vm.changImgSrc }
                }),
                _vm._v(" "),
                _vm.imgCodeErr
                  ? _c("p", { staticClass: "errTip" }, [
                      _vm._v(_vm._s(_vm.imgCodeErrTip))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.msgErr
                  ? _c("p", { staticClass: "errTip msgErrTip" }, [
                      _vm._v(_vm._s(_vm.msgErrTip))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  staticClass: "longInput confirm",
                  attrs: { type: "button", value: "登录" },
                  on: { click: _vm.passLogin }
                })
              ])
            : _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.phone,
                      expression: "phone"
                    }
                  ],
                  staticClass: "loginInput longInput",
                  attrs: {
                    type: "text",
                    maxlength: "11",
                    placeholder: "手机号"
                  },
                  domProps: { value: _vm.phone },
                  on: {
                    blur: _vm.checkFastPhone,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.phone = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _vm.phoneErr
                  ? _c("p", { staticClass: "errTip" }, [
                      _vm._v(_vm._s(_vm.phoneErrTip))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.phoneCode,
                      expression: "phoneCode"
                    }
                  ],
                  staticClass: "loginInput midInput",
                  attrs: {
                    type: "text",
                    placeholder: "短信验证码",
                    maxlength: "6"
                  },
                  domProps: { value: _vm.phoneCode },
                  on: {
                    blur: _vm.checkPhoneCode,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.phoneCode = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "codeImg getPhoneCode",
                  attrs: {
                    type: "button",
                    value: _vm.codeTime,
                    disabled: _vm.noSend
                  },
                  on: { click: _vm.getPhoneCode, blur: _vm.clearTips }
                }),
                _vm._v(" "),
                _vm.phoneCodeErr
                  ? _c("p", { staticClass: "errTip" }, [
                      _vm._v(_vm._s(_vm.phoneCodeErrTip))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.msgErr
                  ? _c("p", { staticClass: "errTip msgErrTip" }, [
                      _vm._v(_vm._s(_vm.msgErrTip))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.msgErr
                  ? _c("p", { staticClass: "errTip msgErrTip" }, [
                      _vm._v(_vm._s(_vm.msgErrTip))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  staticClass: "longInput confirm",
                  attrs: { type: "button", value: "登录" },
                  on: { click: _vm.phoneLogin }
                })
              ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loginBottom" }, [
      _c(
        "a",
        {
          attrs: {
            href: "http://newsso.forex.com.cn/#/findPassword",
            target: "view_window"
          }
        },
        [_vm._v("忘记密码？")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loginRegister" }, [
      _c("span", [_vm._v("还没有帐号？    ")]),
      _c(
        "a",
        {
          attrs: {
            href: "http://newsso.forex.com.cn/#/register",
            target: "view_window"
          }
        },
        [_vm._v("立即注册")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3768681b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3768681b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/popLogin/popLogin.vue
// module id = 520
// module chunks = 0 1